import React, { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import {
  Button,
  Popconfirm,
  Modal,
  InputNumber
} from 'antd';
import {
  reloadLeadsAtom,
  editCommissionsAtom,
  notificationsAtom
} from '../../../../atoms/Atoms';
import api from '../../../../api/api';
import { thousandAutoDecimal } from '../../../../functions';

function LeadCommissionsModal() {
  const { t } = useTranslation();
  const [lead, setLead] = useRecoilState(editCommissionsAtom);
  const [reloadLeads, setReloadLeads] = useRecoilState(reloadLeadsAtom);
  const [notifications, setNotifications] = useRecoilState(notificationsAtom);
  const [leadData, setLeadData] = useState(null);
  const [loading, setLoading] = useState(false);

  function update() {
    setLoading(true);
    api.post('leads/update', leadData)
      .then((response) => {
        setLoading(false);
        if (response?.data?.error) {
          setNotifications([
            ...notifications,
            {
              title: t('error'),
              description: response?.data?.error,
              error: true,
            },
          ]);
        } else {
          setNotifications([
            ...notifications,
            {
              title: t('success'),
              description: response.data.message,
              error: false,
            },
          ]);
          setReloadLeads(true);
          setLead(null);
        }
      })
      .catch((error) => {
        setLoading(false);
        setNotifications([
          ...notifications,
          {
            title: t('error'),
            description: error.message,
            error: true,
          },
        ]);
      });
  }

  useEffect(() => {
    setLeadData(lead);
  }, [lead]);

  return (
    <Modal
      title={t('commissions')}
      zIndex={999}
      open={lead}
      onCancel={() => setLead(null)}
      footer={[
        <Button
          key="update"
          type="primary"
          loading={loading}
          onClick={() => update()}
        >
          {t('update')}
        </Button>
      ]}
    >
      <div className="space-y-4">
        <div>
          <strong>{t('closer_commision_pct')}</strong>
          <InputNumber
            value={leadData?.closerCommisionPCT}
            disabled={loading}
            min={0}
            className="w-full"
            step="0.01"
            addonAfter="%"
            formatter={(value) => thousandAutoDecimal(value)}
            parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
            onChange={(obj) => setLeadData({
              ...leadData,
              closerCommisionPCT: obj
            })}
          />
        </div>
        <div>
          <strong>{t('closer_commision_amount')}</strong>
          <InputNumber
            value={leadData?.closerCommisionAmount}
            disabled={loading}
            min={0}
            className="w-full"
            step="0.01"
            addonBefore="$"
            formatter={(value) => thousandAutoDecimal(value)}
            parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
            onChange={(obj) => setLeadData({
              ...leadData,
              closerCommisionAmount: obj
            })}
          />
        </div>
        <div>
          <strong>{t('setter_commision_amount')}</strong>
          <InputNumber
            value={leadData?.setterCommisionAmount}
            disabled={loading}
            min={0}
            className="w-full"
            step="0.01"
            addonBefore="$"
            formatter={(value) => thousandAutoDecimal(value)}
            parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
            onChange={(obj) => setLeadData({
              ...leadData,
              setterCommisionAmount: obj
            })}
          />
          <Button
            type="primary"
            className="w-full mt-2 mb-4"
            onClick={() => {
              let commission = 0;
              if (leadData?.systemSize >= 0 && leadData?.systemSize <= 5999) {
                commission = 1000;
              } else if (leadData?.systemSize >= 6000 && leadData?.systemSize <= 9999) {
                commission = 1500;
              } else if (leadData?.systemSize >= 10000 && leadData?.systemSize <= 14999) {
                commission = 2000;
              } else if (leadData?.systemSize >= 15000) {
                commission = 3000;
              }
              setLeadData({
                ...leadData,
                setterCommisionAmount: commission
              });
            }}
          >
            {t('calculate_setter_commission_based_on_system_size')}:<span className="font-bold ml-2">{leadData?.systemSize} {t('watts')}</span>
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default LeadCommissionsModal;
